import React from 'react';
import PropTypes from 'prop-types';

const Home = props => {
  const { history } = props;
  const goTo = page => () => {
    history.push(page);
  };
  return (
    <div id="background">
      <div>
        <button className="button" onClick={goTo('signup')}>Sign up</button>
      </div>
      <div id="or">OR</div>
      <div>
        <button className="button" onClick={goTo('signin')}>Sign in</button>
      </div>
    </div>
  );
};

Home.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default Home;
